import * as React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import './TroughBanner.scss';
import MESSAGES from './TroughBanner.messages';
import trough_banner from '../../../assets/images/trough_banner.jpg';

export interface TroughBannerProps {
}

export default class TroughBanner extends React.Component<TroughBannerProps, any> {
  public render() {
    return (
      <Link to="/troughs" className="trough-banner">
        <div className="trough-banner__image">
          <img src={trough_banner} />
        </div>
        <div className="trough-banner__body">
          <div className="trough-banner__icon">
            <FontAwesomeIcon icon={faInfo} />
          </div>
          <div className="trough-banner__copy">
            <div className="trough-banner__label"><FormattedMessage {...MESSAGES.label} /></div>
            <div className="trough-banner__text"><FormattedMessage {...MESSAGES.text} /></div>
          </div>
        </div>
      </Link>
    );
  }
}